<div class="dialog dialog-lg">
  <mat-dialog-actions class="dialog-header" align="start">
    <button mat-dialog-close class="botao-close">×</button>
  </mat-dialog-actions>
  <p class="texto">
    Bem vindo/a à plataforma SimCAQ-Vix, uma plataforma gratuita que calcula o
    custo da oferta de ensino em condições de qualidade nas escolas públicas de
    educação básica, ou como chamamos, o Custo-aluno qualidade. O que você
    deseja fazer?
  </p>
  <div class="container-opcoes">
    <div class="container-opcao container-mini-tutorial">
      <img
        class="icon"
        ngSrc="assets/imagens/tutorial-home/tutorial_icon.png"
        alt="mini-tutorial"
        height="264"
        width="264"
      />
      <div class="texto-container">
        <mat-card-title class="title"> Mini tutorial </mat-card-title>
        <mat-card-subtitle> Tutorial rápido, por escrito. </mat-card-subtitle>
      </div>
      <button class="botao-mini-tutorial btn" mat-raised-button>
        Ir para o mini tutorial
      </button>
    </div>
    <div class="container-opcao">
      <img
        class="icon"
        ngSrc="assets/imagens/tutorial-home/video_tutorial_icon.png"
        alt="video-tutorial"
        height="264"
        width="264"
      />
      <div class="texto-container">
        <mat-card-title class="title"> Vídeo tutorial </mat-card-title>
        <mat-card-subtitle>
          Tutorial detalhado da plataforma.
        </mat-card-subtitle>
      </div>
      <button class="botao-video-tutorial btn" mat-raised-button>
        Ir para tutorial em vídeo
      </button>
    </div>
    <div class="container-opcao skip-tutorial">
      <img
        class="icon"
        ngSrc="assets/imagens/tutorial-home/skip_tutorial_icon.png"
        alt="skip-tutorial"
        height="264"
        width="264"
      />
      <div class="texto-container">
        <mat-card-title class="title"> Começar simulação </mat-card-title>
        <mat-card-subtitle> Já conhece a plataforma? </mat-card-subtitle>
      </div>
      <button
        (click)="simular()"
        class="botao-skip-tutorial btn"
        mat-raised-button
      >
        Pular tutorial
      </button>
    </div>
  </div>
</div>
